import { Component, OnInit } from '@angular/core';
import {CoreComponent} from '../core/core.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Results} from '../core/results';
import {Meta, Title} from '@angular/platform-browser';
import {Course} from './course/course';
import {CoursesService} from './courses.service';
import {CourseComponent} from './course/course.component';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
declare var bootbox: any;
@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent extends CoreComponent<Course> {
  @BlockUI() blockUI: NgBlockUI;
  constructor(protected servicesService: CoursesService, public route: ActivatedRoute,
              public meta: Meta, public title: Title,protected gaService: GoogleAnalyticsService,
              private modalService: NgbModal, private matSnackBar: MatSnackBar) {
    super(servicesService,route);
    this.title.setTitle('Courses');
  }

  public search() {
    this.blockUI.start();
    this.servicesService.search(this.currentPage, this.perPage, this.order, this.orderBy, this.keyword)
      .subscribe((data: Results<Course>) => {
        this.results = data;
        this.blockUI.stop();
      }, (error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        this.matSnackBar.open(error.error.message, 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      });
  }

  remove(item: Course){
    const that = this;
    bootbox.confirm({
      title: 'Are you sure you want to delete?',
      message: '<strong>'+item.name+'</strong>',
      callback: function(result) {
        if (result === null) {
        } else if (result === true) {

          that.servicesService.delete(item.id).subscribe(()=>{
            that.search();
          }, (error: HttpErrorResponse) => {
            that.blockUI.stop();
            that.gaService.exception(error.error?.message, true);
            that.matSnackBar.open(error.error.message, 'Okay', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          });
        }
      }
    });
  }
  newItem() {
    this.item = new Course();
    this.open(this.item);
  }
  open(item: Course) {
    const modalRef = this.modalService.open(CourseComponent, {fullscreen:true, modalDialogClass:'animate-bottom'});
    modalRef.componentInstance.item= item;
    modalRef.componentInstance.name = 'World';
    modalRef.closed.subscribe(() => {
      this.search();
    });
  }


}
